import { render, staticRenderFns } from "./InquiryResInput.vue?vue&type=template&id=272d3f47&scoped=true&"
import script from "./InquiryResInput.vue?vue&type=script&lang=js&"
export * from "./InquiryResInput.vue?vue&type=script&lang=js&"
import style0 from "./InquiryResInput.vue?vue&type=style&index=0&id=272d3f47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d3f47",
  null
  
)

export default component.exports